import * as WebViewActionTypes from './action-types.constants';

export const ready = (medscape = {}, tracking = {}) => ({
	type: WebViewActionTypes.READY,
	medscape,
	tracking
})


export const onDocumentReady = (event) => ({
	type: WebViewActionTypes.DOCUMENT_READY,
	event
})

export const onWindowLoad = (event) => ({
	type: WebViewActionTypes.WINDOW_LOAD,
	event
})

export const updateLocation = (location) => ({
	type: WebViewActionTypes.UPDATE_LOCATION,
	location
})

export const resize = (event) => ({
	type: WebViewActionTypes.RESIZE,
	event
})

export const omnitureTracking = (value,el, checkMedscapePageLink) => ({
	type: WebViewActionTypes.OMNITURE_TRACKING,
	value,
	el,
	checkMedscapePageLink
})

export const postCp = (data) => ({
	type: WebViewActionTypes.POST_CP,
	data
})

export const trackPageView = (location) => {
	return {
		type: WebViewActionTypes.TRACK_PAGEVIEW,
		location
	}

}